import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface rolePermissionState {
	isLoading: boolean;
	rolePermissionList: any;
	totalRolePermissionList: number;
	RolePermissionDetail: any;
	rolePermissionModule: any;
}

const initialState: rolePermissionState = {
	isLoading: false,
	rolePermissionList: [],
	totalRolePermissionList: 0,
	RolePermissionDetail: [],
	rolePermissionModule: []
};

const rolePermissionSlice = createSlice({
	name: 'rolePermission',
	initialState,
	reducers: {
		clearRoles: (state) => {
			state.RolePermissionDetail = [];
		},
		addrolePermissionInIt: state => {
			state.isLoading = true;
		},
		addrolePermissionSuccess: state => {
			state.isLoading = false;
		},
		addrolePermissionError: state => {
			state.isLoading = false;
		},
		getAllrolePermissionListInIt: state => {
			state.isLoading = true;
		},
		getAllrolePermissionListSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.isLoading = false;
			state.totalRolePermissionList = data.count;
			state.rolePermissionList = data.roles;
		},
		getAllrolePermissionListError: state => {
			state.isLoading = false;
			state.rolePermissionList = [];
			state.totalRolePermissionList = 0;
		},

		updaterolePermissionStatusInit: state => {
			state.isLoading = true;
		},
		updaterolePermissionStatusSuccess: state => {
			// state.isLoading = true;
		},
		updaterolePermissionStatusError: state => {
			state.isLoading = false;
		},
		deleterolePermissionInit: state => {
			state.isLoading = true;
		},
		deleterolePermissionSuccess: state => {
			state.isLoading = false;
		},
		deleterolePermissionError: state => {
			// state.isLoading = false;
		},
		getrolePermissionByIdInIt: state => {
			state.isLoading = true;
		},
		getrolePermissionByIdSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;

			state.RolePermissionDetail = data.role;
			state.isLoading = false;
		},
		getrolePermissionByIdError: state => {
			state.isLoading = false;
		},
		clearrolePermissionDetail: state => {
			state.RolePermissionDetail = [];
		},
		getRolePermissionModuleInIt: state => {
			state.isLoading = true;
		},
		getRolePermissionModuleSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;

			state.isLoading = false;
			state.rolePermissionModule = data.modules;
		},
		getRolePermissionModuleError: state => {
			state.isLoading = false;
		}
	}
});

export const {
	clearRoles,
	getAllrolePermissionListError,
	getAllrolePermissionListInIt,
	getAllrolePermissionListSuccess,
	addrolePermissionError,
	addrolePermissionInIt,
	addrolePermissionSuccess,
	clearrolePermissionDetail,
	deleterolePermissionError,
	deleterolePermissionInit,
	deleterolePermissionSuccess,
	getrolePermissionByIdError,
	getrolePermissionByIdInIt,
	getrolePermissionByIdSuccess,
	updaterolePermissionStatusError,
	updaterolePermissionStatusInit,
	updaterolePermissionStatusSuccess,
	getRolePermissionModuleError,
	getRolePermissionModuleInIt,
	getRolePermissionModuleSuccess
} = rolePermissionSlice.actions;

export default rolePermissionSlice.reducer;
